import React, { createContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getDownloadExcel } from "../../api/Api";
import RouteConstants from "../../constants/routesContent.json";

export const StatusCategoryContext = createContext({});
const StatusCategoryContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [statusCategory, setStatusCategory] = useState();
  const [excelDownload, setExcelDownload] = useState("");
  const [zoneNewExcel, setZoneNewExcel] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [statusCode, setStatusCode] = useState(0);
  const restructureApiResponse = (data) => {
    const iteratedObject = data?.map((item) => {
      const categoryOne = item?.category?.filter((item) => {
        return item.id == 1;
      });
      const categoryTwo = item?.category?.filter((item) => {
        return item.id == 2;
      });
      return {
        categoryName: item?.name ? item.name : "-",
        totalCount: item?.total ? item.total : "-",
        zoneOneCount:
          categoryOne?.[0]?.id === 1 ? categoryOne?.[0]?.total : "-",
        zoneTwoCount:
          categoryTwo?.[0]?.id === 2 ? categoryTwo?.[0]?.total : "-",
      };
    });

    return iteratedObject;
  };

  useEffect(() => {
    const apiResponseFromState = location?.state?.result?.status;
    const apiExcelSheet = location?.state?.excelFile;
    const iteratedResponse = restructureApiResponse(apiResponseFromState);
    setStatusCategory(iteratedResponse);
  }, []);

  const goBack = () => {
    navigate(-1);
  };

  const downloadExcelSheet = async () => {
    setSpinnerStatus(true);
    const data = {
      search: "status",
      filter: "cat",
      empData: "",
      fromDate: "",
      toDate: "",
      zoneFilter: "",
      categoryFilter: "",
    };
    try {
      const response = await getDownloadExcel(data);
      if (response.data.status === 200) {
        setSpinnerStatus(false);
        setZoneNewExcel(response?.data?.data?.filename);
      }
    } catch (error) {
      setSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };
  useEffect(() => {
    downloadExcelSheet();
  }, []);

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };

  const providerValue = {
    goBack,
    statusCategory,
    excelDownload,
    zoneNewExcel,
    spinnerStatus,
    logout,
    setShowAlert,
    alertMessage,
    statusCode,
    showAlert,
  };
  return (
    <StatusCategoryContext.Provider value={providerValue}>
      {children}
    </StatusCategoryContext.Provider>
  );
};

export default StatusCategoryContextProvider;
